import {
  GET_ITEMS_FOR_EXPORT_SUCCESS,
  GET_MONTHLY_BILL_FAILURE,
  GET_MONTHLY_BILL_REQUEST,
  GET_MONTHLY_BILL_SUCCESS,
} from '../../actionConstants';

import apiClient from '../../apiClient';

export const getMonthlyBill = (dispatch, queryParams, isExport) =>
  dispatch({
    type: GET_MONTHLY_BILL_REQUEST,
    withoutLoading: isExport,
    payload: apiClient.statistics.getBillingReport(queryParams).then(
      (res) => {
        dispatch({
          type: isExport
            ? GET_ITEMS_FOR_EXPORT_SUCCESS
            : GET_MONTHLY_BILL_SUCCESS,
          res,
        });
        return res;
      },
      (err) => {
        dispatch({ type: GET_MONTHLY_BILL_FAILURE, err });
        return err;
      },
    ),
  });
